import { loadable } from '../../common/utils/lazyLoading';
const AssetRegister = loadable(() => import('./AssetRegister'));
export default [
    {
        id: 'asset_register',
        title: 'Asset Register',
        route: 'asset-register',
        component: AssetRegister,
        withEntityFormEditButton: true,
        icon: 'ed-asset-register',
        permission: 'asset_register',
    },
];
